export const breadcrumbs = {
  root: {
    name: '/',
    displayName: 'Home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Inicio Miranda / Dashboard',
    },
    {
      name: 'finanzas',
      displayName: 'Finanzas',
      disabled: true,
      children: [
        {name: 'clientesCredito', displayName: 'Clientes Credito'},
        {name: 'notasDeCredito', displayName: 'Notas de Credito'},
        {name: 'listaProveedores', displayName: 'Proveedores'},
        {name: 'estadoCuentaProveedor', displayName: 'Estado Cuenta Proveedor'},
      ]
    },
    {
      name: 'compras',
      displayName: 'compras',
      disabled: true,
      children: [
        {name: 'ordenCompra', displayName: 'Orden de Compra',},
        {name: 'proveedores', displayName: 'Crear Proveedor',},
        {name: 'listar', displayName: 'listar',},
        {name: 'sugeridoCompra', displayName: 'Sugerido de Compra',},
        {name: 'reporteInventario', displayName: 'Reporte de Inventario',},
        {name: 'reportes', displayName: 'Reportes',},
        {name: 'transporte', displayName: 'Transporte',},
        {name: 'productos', displayName: 'Productos',},
      ],
    },
    {
      name: 'producto',
      displayName: 'Productos',
      disabled: true,
      children: [
        {name: 'producto', displayName: 'Productos'},
        {name: 'listarProductoMiranda', displayName: 'Listar Producto Miranda'},
        {name: 'marcas', displayName: 'Marca Vehiculo'},
        {name: 'categoriaProducto', displayName: 'Categoria'},
        {name: 'clasificacionProducto', displayName: 'Clasificacion Producto'},
        {name: 'familiaProducto', displayName: 'Familia Producto'},
        {name: 'vehiculos', displayName: 'Vehiculos'},
        {name: 'modelo',displayName: 'Modelo Vehiculo'},
        {name: 'marcaProducto',displayName: 'Marca Producto'}
      ]
    },
    {
      name: 'asociacion',
      displayName: 'asociacion',
      disabled: true,
      children: [
        {name: 'asociacion',displayName: 'Asociación'},
        {name: 'asociacionManual',displayName: 'Asociación Manual'}
      ]
    },
    {
      name: 'recepcion',
      displayName: 'recepcion',
      disabled: true,
      children: [
        {
          name: 'recepcion',
          displayName: 'Recepción',
        },
        {
          name: 'documento',
          displayName: 'Listar Documentos',
        },
        {
          name: 'crearDocumentos',
          displayName: 'Crear Documento',
        },
        {
          name: 'listarRecepcion',
          displayName: 'Listar',
        },
        {
          name: 'recepcionGuia',
          displayName: 'Guia Traslado',
        },
        {
          name: 'reportesRecepcion',
          displayName: 'Reportes',
        },
        {
          name: 'productoPendiente',
          displayName: 'Producto Pendiente',
        },
      ],
    },
    {
      name: 'marketing',
      displayName: 'Marketing',
      disabled: true,
      children: [
        {
          name: 'categoria',
          displayName: 'Categoria',
        },
        {
          name: 'precios',
          displayName: 'Precios',
        },
        {
          name: 'ofertas',
          displayName: 'Ofertas',
        }
      ]
    },
    {
      name: 'sucursal',
      displayName: 'Sucursal',
      disabled: true,
      children: [
        {
          name: 'sucursales',
          displayName: 'Crear Sucursales',
        }]
    },
    {
      name: 'ventas',
      displayName: 'Ventas',
      disabled: true,
      children: [
        {
          name: 'nueva',
          displayName: 'Nueva Venta',
        },
        {
          name: 'listarVentas',
          displayName: 'Listar Venta'
        },
        {
          name: 'carroVentas',
          displayName: 'Carro'
        }
      ]
    },
    {
      name: 'caja',
      displayName: 'Caja',
      disabled: true,
      children: [
        {
          name: 'caja',
          displayName: 'Caja',
        },
        {
          name: 'historico',
          displayName: 'Historico',
        },
        {
          name: 'pagar',
          displayName: 'Pagar',
        },
        {
          name: 'retiroCaja',
          displayName: 'Retiro Caja',
        },
        {
          name: 'rendicion',
          displayName: 'Rendición',
        },
        {
          name: 'verCaja',
          displayName: 'Ver Caja',
        },
        {
          name: 'ingresos',
          displayName: 'Ingresos',
        },
        {
          name: 'egresos',
          displayName: 'Egresos',
        },
        {
          name: 'cerrarCaja',
          displayName: 'Cerrar Caja',
        }
      ]
    },
    {
      name: 'Empaque',
      displayName: 'Empaque',
      disabled: true,
      children: [
        {
          name: 'empaque',
          displayName: 'Empaque Miranda',
        },
      ]
    },
    {
      name: 'usuarios',
      displayName: 'Usuarios',
      disabled: true,
      children: [
        {
          name: 'listarUsuarios',
          displayName: 'Listar Usuarios',
        }]
    },
    {
      name: 'informatica',
      displayName: 'Informatica',
      disabled: true,
      children: [
        {
          name: 'solicitud-requerimiento',
          displayName: 'Solicitud Requerimiento',
        }]
    },
    {
      name: 'bodega',
      displayName: 'Bodega',
      disabled: true,
      children: [
        {
          name: 'bodega',
          displayName: 'Bodega',
        },
        {
          name: 'devoluciones',
          displayName: 'Agregar Devolución',
        },
        {
          name: 'devolucionesGeneradas',
          displayName: 'Ver Devoluciones',
        },
        {
          name: 'generarGuias',
          displayName: 'Generar Guia',
        },
        {
          name: 'guiasTraslado',
          displayName: 'Guias Traslado'
        },
        {
          name: 'generarDevolucion',
          displayName: 'Generar Devolución',
        },
        {
          name: 'pedidoEntreSucursales',
          displayName: 'Pedidos Entre Sucursales',
        },
        {
          name: 'ajusteStock',
          displayName: 'Ajuste Stock',
        },
      ]
    },
    {
      name: 'post-venta',
      displayName: 'Post Venta',
      disabled: true,
      children: [
        {
          name: 'devolucionCliente',
          displayName: 'Devolucion',
        },
        {
          name: 'verDevolucion',
          displayName: 'View',
        },
        {
          name: 'historicoCliente',
          displayName: 'Historico',
        },
      ]
    },
    {
      name: 'RecursosHumanos',
      displayName: 'Recursos Humanos',
      disabled: true,
      children: [
        {
          name: 'comisiones',
          displayName: 'Comisiones',
        },
      ]
    },
    {
      name: 'Clientes',
      displayName: 'Clientes',
      disabled: true,
      children: [
        {
          name: 'HistoricoCliente',
          displayName: 'Historico',
        },
      ]
    },



    {
      name: 'statistics',
      displayName: 'menu.statistics',
      disabled: true,
      children: [
        {
          name: 'charts',
          displayName: 'menu.charts',
        },
        {
          name: 'progress-bars',
          displayName: 'menu.progressBars',
        },
      ],
    },
    {
      name: 'forms',
      displayName: 'menu.forms',
      disabled: true,
      children: [
        {
          name: 'form-elements',
          displayName: 'menu.formElements',
        },
        {
          name: 'form-wizards',
          displayName: 'menu.formWizards',
        },
        {
          name: 'medium-editor',
          displayName: 'menu.mediumEditor',
        },
      ],
    },
    {
      name: 'tables',
      displayName: 'menu.tables',
    },
    {
      name: 'ui',
      displayName: 'menu.uiElements',
      disabled: true,
      children: [
        {
          name: 'typography',
          displayName: 'menu.typography',
        },
        {
          name: 'buttons',
          displayName: 'menu.buttons',
        },
        {
          name: 'collapse',
          displayName: 'menu.collapse',
        },
        {
          name: 'filters',
          displayName: 'menu.filters'
        },
        {
          name: 'color-pickers',
          displayName: 'menu.colorPickers',
        },
        {
          name: 'timelines',
          displayName: 'menu.timelines',
        },
        {
          name: 'notifications',
          displayName: 'menu.notifications',
        },
        {
          name: 'dropdowns',
          displayName: 'menu.dropdowns',
        },
        {
          name: 'icon-sets',
          displayName: 'menu.icons',
          children: [
            {
              displayName: 'concrete',
              name: 'icon-set',
            },
          ],
        },
        {
          name: 'spinners',
          displayName: 'menu.spinners',
        },
        {
          name: 'grid',
          displayName: 'menu.grid',
        },
        {
          name: 'modals',
          displayName: 'menu.modals',
        },
        {
          name: 'file-upload',
          displayName: 'menu.fileUpload',
        },
        {
          name: 'tags',
          displayName: 'menu.tags',
        },
        {
          name: 'cards',
          displayName: 'menu.cards',
        },
        {
          name: 'tree-view',
          displayName: 'menu.treeView',
        },
      ],
    },
    {
      name: 'extra',
      displayName: 'menu.extra',
    },
    {
      name: 'maps',
      displayName: 'menu.maps',
      disabled: true,
      children: [
        {
          name: 'google-maps',
          displayName: 'Google Maps',
        },
        {
          name: 'yandex-maps',
          displayName: 'Yandex Maps',
        },
        {
          name: 'leaflet-maps',
          displayName: 'Leaflet Maps',
        },
        {
          name: 'bubble-maps',
          displayName: 'Bubble Maps',
        },
        {
          name: 'line-maps',
          displayName: 'Line Maps',
        },
      ],
    },
    {
      name: 'pages',
      displayName: 'menu.pages',
      disabled: true,
      children: [
        {
          name: '404-pages',
          displayName: '404 Pages',
        },
      ],
    },
  ],
}
